import { useQuery } from '@tanstack/react-query';
import { excludedUsersKey } from '../lib/queryKeys';
import type { ExcludedUser } from '../lib/excludedUser';

export interface UseExcludedUsers {
  users: ExcludedUser[] | undefined;
  isPending: boolean;
  isFetching: boolean;
  isError: boolean;
  retry: () => void;
}

// Errors stay inline (default `throwOnError: false`): a failed list must surface a retry on its own
// card, never tear down the card beside it through the page boundary.
export function useExcludedUsers(
  slug: string,
  fetchExcludedUsers: (slug: string) => Promise<ExcludedUser[]>,
): UseExcludedUsers {
  const query = useQuery({
    queryKey: excludedUsersKey(slug),
    queryFn: () => fetchExcludedUsers(slug),
  });

  return {
    users: query.data,
    isPending: query.isPending,
    isFetching: query.isFetching,
    isError: query.isError,
    retry: () => {
      void query.refetch();
    },
  };
}
